module.exports = __webpack_public_path__ + "img/2-5.70304b66.png";